import {
  CreateGUFExpandedRealisedInstallationTask,
  EditGUFExpandedRealisedInstallationTask,
  QualityRegimeOptions,
} from "@nens/brostar/uploadapi-client";

import { BrostarUiSchema } from "@/libs/brostar-form";

import { createGufUiSchemaLibrary } from "./guf-ui-schema-library";

export function useGufExpandedRealisedInstallationUiSchema(
  qualityRegimeValue: QualityRegimeOptions | undefined
): BrostarUiSchema<
  CreateGUFExpandedRealisedInstallationTask | EditGUFExpandedRealisedInstallationTask
> {
  const {
    projectNumber,
    qualityRegime,
    deliveryAccountableParty,
    broId,
    correctionReason,
    installationFunction,
    realisedInstallationId,
    realisedLoopPos,
    startValidity,
    realisedLoopId,
    endDepthBottom,
    loopType,
    realisedGeometryType,
    segments,
    realisedSurfaceInfiltrationId,
    realisedSurfaceInfiltrationPos,
    realisedWellId,
    wellFunctions,
    height,
    wellDepth,
    wellPos,
    publiclyAvailable,
    relativeTemperature,
    realisedScreenId,
    screenType,
    topScreenDepth,
    length,
    realisedScreenPos,
  } = createGufUiSchemaLibrary(qualityRegimeValue);

  const uiSchema: BrostarUiSchema<
    CreateGUFExpandedRealisedInstallationTask | EditGUFExpandedRealisedInstallationTask
  > = {
    "ui:order": ["metadata", "sourcedocumentData"],
    metadata: {
      "ui:title": "Metadata",
      projectNumber,
      qualityRegime,
      deliveryAccountableParty,
      broId,
      correctionReason,
    },
    sourcedocumentData: {
      "ui:title": "Brondocumentgegevens",
      "ui:order": [
        "realisedInstallationId",
        "installationFunction",
        "realisedLoopPos",
        "startValidity",
        "realisedLoops",
        "realisedSurfaceInfiltrations",
        "realisedWells",
      ],
      realisedInstallationId,
      installationFunction,
      realisedLoopPos,
      startValidity,
      realisedLoops: {
        "ui:options": { labelField: "realisedLoopId" },
        items: {
          "ui:order": [
            "realisedLoopId",
            "endDepthBottom",
            "loopType",
            "geometryType",
            "realisedLoopPos",
            "segments",
          ],
          realisedLoopId,
          endDepthBottom,
          loopType,
          geometryType: realisedGeometryType,
          realisedLoopPos,
          segments,
        },
      },
      realisedSurfaceInfiltrations: {
        "ui:options": { labelField: "realisedSurfaceInfiltrationId" },
        items: {
          "ui:order": ["realisedSurfaceInfiltrationId", "realisedSurfaceInfiltrationPos"],
          realisedSurfaceInfiltrationId,
          realisedSurfaceInfiltrationPos,
        },
      },
      realisedWells: {
        "ui:options": { labelField: "realisedWellId" },
        items: {
          "ui:order": [
            "realisedWellId",
            "wellFunctions",
            "height",
            "wellDepth",
            "wellPos",
            "publiclyAvailable",
            "relativeTemperature",
            "realisedScreens",
          ],
          realisedWellId,
          wellFunctions,
          height,
          wellDepth,
          wellPos,
          publiclyAvailable,
          relativeTemperature,
          realisedScreens: {
            "ui:options": { labelField: "realisedScreenId" },
            items: {
              "ui:order": [
                "realisedScreenId",
                "screenType",
                "topScreenDepth",
                "length",
                "geometryType",
                "realisedScreenPos",
                "segments",
              ],
              realisedScreenId,
              screenType,
              topScreenDepth,
              length,
              geometryType: realisedGeometryType,
              realisedScreenPos,
              segments,
            },
          },
        },
      },
    },
  };

  return uiSchema;
}
